<script setup lang="ts">
import IncomingCallOverlayComponent from '@toolify/client/src/modules/call/components/IncomingCallOverlayComponent.vue'
import {useCallInviteStore} from '@toolify/client/src/stores/CallInviteStore/useCallInviteStore'

const callInviteStore = useCallInviteStore()
</script>

<template>
  <IncomingCallOverlayComponent
    v-if="callInviteStore.activeRingingInvite"
    :callInvite="callInviteStore.activeRingingInvite"
    :key="callInviteStore.activeRingingInvite.id"
  />
</template>
